import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar, Autoplay } from "swiper/modules"; // Import Scrollbar module
import "swiper/css";
import "swiper/css/scrollbar";
import SliderCarts from "../customcard/sliderCart";
import { useRef } from "react";
function ResponsiveSlider({data,bestSeller}) {
     const swiperRef =useRef(null);
   
  const settings = {
    modules: [Navigation, Scrollbar, Autoplay], // Add Scrollbar module
    scrollbar: { draggable: true }, // Enable draggable scrollbar

    // Default settings
    slidesPerView: 1, 
     // Number of slides visible at a time
    spaceBetween: 10, // Space (gap) between slides in pixels
    slidesPerGroup: 1, // Number of slides to scroll per swipe
  
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  
  
    // Responsive breakpoints
    breakpoints: {
      // When window width is >= 640px
      300: {
        slidesPerView: 2, // Show 2 slides
        slidesPerGroup: 1, // Scroll 2 slides at a time
        spaceBetween: 4, // 20px gap between slides
      },
      520: {
        slidesPerView: 3, // Show 2 slides
        slidesPerGroup: 1, // Scroll 2 slides at a time
        spaceBetween: 8, // 20px gap between slides
      },
    
      // When window width is >= 768px
      768: {
        slidesPerView: 3, // Show 3 slides
        slidesPerGroup: 1, // Scroll 3 slides at a time
        spaceBetween: 10, // 30px gap between slides
      },
      // When window width is >= 1024px
      1024: {
        slidesPerView: 4, // Show 4 slides
        slidesPerGroup: 1, // Scroll 4 slides at a time
        spaceBetween: 10, // 40px gap between slides
      },
      1200: {
        slidesPerView: 5, // Show 5 slides
        slidesPerGroup: 1, // Scroll 4 slides at a time
        spaceBetween: 10, // 40px gap between slides
      },
    },
    freeMode: true, // Enable free scrolling
  };
  
  
  return (
    <div className="relative mx-auto w-full" >
 
    <Swiper ref={swiperRef} style={{ height: "100%" ,overflow:"visible"}}  {...settings}>
       
      {data?.length>0?
        data?.map((item,index)=>(
          <SwiperSlide  key={index} className="w-full h-full">

            <SliderCarts key={index} bestSeller={bestSeller} item={item} img={item.images[0]} name={item.name} desc={item.description} price={item.price} mrp={item.mrp} discount={Math.ceil(((item.mrp-item.price)/item.mrp)*100)} stockQuantity={item.stockQuantity}/>
            </SwiperSlide>
        ))
        :Array.from({ length: 20 }).map((_, key) => {
  return (
    <SwiperSlide key={key} className="w-full h-full">
      <div className="flex items-center justify-center  w-full h-[40vh] animate-pulse bg-gray-300 rounded-sm">
        {/* Optional loader content */}
      </div>
    </SwiperSlide>
  );
})

      }
      </Swiper>
    </div>
  );
}

export default ResponsiveSlider;
